import s from "./Logo.module.css";

const RUTA = "/logo-aceros-lima.jpg";
const ALT = "Grupo Aceros Lima — Corte, plegado y rolado";

/**
 * Logotipo de Grupo Aceros Lima (public/logo-aceros-lima.jpg).
 *
 * El original es un lockup vertical sobre fondo blanco solido. Para no
 * redibujarlo ni alterar sus colores:
 *  - sobre fondo claro se integra con `mix-blend-mode: multiply`;
 *  - en la cabecera se recorta el simbolo y se acompana del logotipo
 *    tipografico, porque el lockup vertical resulta ilegible a 50 px;
 *  - sobre fondo oscuro se usa solo el logotipo tipografico.
 *
 * PENDIENTE: pedir el archivo vectorial (SVG o AI), la version horizontal
 * oficial y la version reversada para fondo oscuro.
 *
 * variante: "lockup" | "completo" | "marca" | "texto"
 */
export default function Logo({ className = "", variante = "lockup" }) {
  if (variante === "texto") {
    return <Wordmark className={className} />;
  }

  if (variante === "marca") {
    return <Simbolo className={className} />;
  }

  if (variante === "completo") {
    return (
      <span className={`${s.completo} ${className}`}>
        <img src={RUTA} alt={ALT} width="640" height="640" />
      </span>
    );
  }

  return (
    <span className={`${s.lockup} ${className}`}>
      <Simbolo className={s.lockupSimbolo} />
      <span className={s.lockupTexto}>
        <Wordmark className={s.lockupWordmark} />
        <span className={s.lockupBajada}>Corte · Plegado · Rolado</span>
      </span>
    </span>
  );
}

/** Recorte del simbolo (la plegadora) dentro del arte original. */
function Simbolo({ className = "" }) {
  return (
    <span className={`${s.marca} ${className}`} aria-hidden="true">
      <img src={RUTA} alt="" width="640" height="640" />
    </span>
  );
}

/** Reproduce el lettering del logotipo con la tipografia del sitio. */
function Wordmark({ className = "" }) {
  return (
    <span className={`${s.wordmark} ${className}`}>
      <span>Grupo</span>
      <span className={s.aceros}>Aceros</span>
      <span>Lima</span>
    </span>
  );
}
